import styled from 'styled-components';
import {Space} from 'antd';
import Tabs from '../../components/Tabs';
import {bordersStyles} from '../../utils/styles';

const TABS_WIDTH = '384px';

const StyledBudgetActiveRightSideContainer = styled.div`
  .ant-tabs-nav {
    .ant-tabs-tab {
      &.ant-tabs-tab-active {
        background-color: transparent;
        border: none;
      }
    }
  }
`;

const StyledBudgetActivePageContainer = styled.div`
  padding: 24px;
  display: flex;
  justify-content: space-between;
  & > div {
    &:nth-of-type(1) {
      width: calc(100% - ${TABS_WIDTH} - 24px);
    }
    &:nth-of-type(2) {
      width: ${TABS_WIDTH};
    }
  }
`;

const StyledBudgetActivePageContent = styled(Space)`
  ${bordersStyles.light};
  background-color: ${props => props.theme.colors.neutral_1};

  border-radius: 4px;
  padding: 24px;
`;

const StyledBudgetActivePageTabs = styled(Tabs)`
  .ant-tabs-content-holder {
    background-color: transparent;
    border: none;
  }

  & > .ant-tabs-content-holder {
    padding: 0;

    .ant-tabs-content {
      margin-top: -1px;
    }

    .ant-tabs-tabpane {
      & > * {
        width: 100%;
      }
    }
  }

  & > .ant-tabs-nav {
    z-index: 1;
    &:before {
      content: none;
    }

    .ant-tabs-tab {
      border: 1px solid ${props => props.theme.colors.neutral_3};
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
  }
`;

export {
  StyledBudgetActiveRightSideContainer,
  StyledBudgetActivePageContainer,
  StyledBudgetActivePageContent,
  StyledBudgetActivePageTabs
}
